import { getRepository } from './repository';

export default {
    getTaxons(vendor) {
        return getRepository().get(`/taxons?vendor=${vendor}`);
    },
    getTaxonDetails(vendor, taxon_url) {
        return getRepository().get(`taxons/detail`, { params: { "vendor": vendor, "taxon_url": taxon_url }})
    }
}